import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Schooltype extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "schooltype";
    }
}

export function Schooltype$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Schooltype", void 0, Schooltype, Metadata_StringCategory$reflection());
}

export function Schooltype_$ctor_Z721C83C5(aName) {
    return new Schooltype(aName);
}

export class School extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school";
    }
}

export function School$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.School", void 0, School, Metadata_StringCategory$reflection());
}

export function School_$ctor_Z721C83C5(aName) {
    return new School(aName);
}

export class Level extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "level";
    }
}

export function Level$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Level", void 0, Level, Metadata_NumberCategory$reflection());
}

export function Level_$ctor_Z721C83C5(aName) {
    return new Level(aName);
}

export class Startlevel extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "startlevel";
    }
}

export function Startlevel$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Startlevel", void 0, Startlevel, Metadata_NumberCategory$reflection());
}

export function Startlevel_$ctor_Z721C83C5(aName) {
    return new Startlevel(aName);
}

export class Student extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "student";
    }
}

export function Student$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Student", void 0, Student, Metadata_NumberCategory$reflection());
}

export function Student_$ctor_Z721C83C5(aName) {
    return new Student(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Nativelanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "nativelanguage";
    }
}

export function Nativelanguage$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Nativelanguage", void 0, Nativelanguage, Metadata_StringCategory$reflection());
}

export function Nativelanguage_$ctor_Z721C83C5(aName) {
    return new Nativelanguage(aName);
}

export class Assignmenttype extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "assignmenttype";
    }
}

export function Assignmenttype$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Assignmenttype", void 0, Assignmenttype, Metadata_StringCategory$reflection());
}

export function Assignmenttype_$ctor_Z721C83C5(aName) {
    return new Assignmenttype(aName);
}

export class Assignmenttext extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "assignmenttext";
    }
}

export function Assignmenttext$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Assignmenttext", void 0, Assignmenttext, Metadata_StringCategory$reflection());
}

export function Assignmenttext_$ctor_Z721C83C5(aName) {
    return new Assignmenttext(aName);
}

export class Comments extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "comments";
    }
}

export function Comments$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Comments", void 0, Comments, Metadata_StringCategory$reflection());
}

export function Comments_$ctor_Z721C83C5(aName) {
    return new Comments(aName);
}

export class Texttype extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "texttype";
    }
}

export function Texttype$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Texttype", void 0, Texttype, Metadata_StringCategory$reflection());
}

export function Texttype_$ctor_Z721C83C5(aName) {
    return new Texttype(aName);
}

export class Datatype extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "datatype";
    }
}

export function Datatype$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Datatype", void 0, Datatype, Metadata_StringCategory$reflection());
}

export function Datatype_$ctor_Z721C83C5(aName) {
    return new Datatype(aName);
}

export class Malform extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "malform";
    }
}

export function Malform$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Malform", void 0, Malform, Metadata_StringCategory$reflection());
}

export function Malform_$ctor_Z721C83C5(aName) {
    return new Malform(aName);
}

export class Num extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "num";
    }
}

export function Num$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Num", void 0, Num, Metadata_NumberCategory$reflection());
}

export function Num_$ctor_Z721C83C5(aName) {
    return new Num(aName);
}

export class Speilvending extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "speilvending";
    }
}

export function Speilvending$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Speilvending", void 0, Speilvending, Metadata_StringCategory$reflection());
}

export function Speilvending_$ctor_Z721C83C5(aName) {
    return new Speilvending(aName);
}

export class Tokencount extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tokencount";
    }
}

export function Tokencount$reflection() {
    return class_type("Corpora.Norm.MetadataCategories.Tokencount", void 0, Tokencount, Metadata_NumberCategory$reflection());
}

export function Tokencount_$ctor_Z721C83C5(aName) {
    return new Tokencount(aName);
}

